import { setUrlDefaults } from '@/wayfinder';

/**
 * Wayfinder `.url()` calls at module scope (e.g. header nav data) need a locale
 * before those modules finish loading. The SSR bundle may import nav modules
 * before `bootstrapWayfinder.ts`, so we set a safe default here.
 */
const fromWindow =
    typeof window !== 'undefined' ? window.__INITIAL_LOCALE__ : undefined;

setUrlDefaults({
    locale: fromWindow === 'en' || fromWindow === 'sr' ? fromWindow : 'en',
});
